import { SET_OPEN_MODAL, SHOW_TOAST, HIDE_TOAST } from "./actionTypes";

export function setOpenModal(payload) {
  return {
    type: SET_OPEN_MODAL,
    isOpen: payload.isOpen,
    entity: payload.entity,
    params: payload.params ? payload.params : {}
  };
}

export function showToast(payload) {
  return {
    type: SHOW_TOAST,
    payload
  };
}

export function hideToast(payload) {
  return {
    type: HIDE_TOAST,
    payload
  };
}
